import React from "react";
import { Box, Link, Tooltip, Typography } from "@mui/material";

export const buildPoProofsPagePath = ({
  instanceUniqueId,
  orderId,
  documentId,
  pathname = "",
}) => {
  const normalizedPathname = String(pathname || "").trim();
  if (normalizedPathname.includes("/pos-proofs/")) {
    return normalizedPathname;
  }

  if (!instanceUniqueId || !orderId || !documentId) {
    return "";
  }

  return `/instance/${instanceUniqueId}/sales/orders/${orderId}/pos-proofs/${documentId}`;
};

const PurchaseOrderNumberCell = ({
  poNumber,
  pdfUrl = "",
  showPoUrl = false,
  pageUrl = "",
}) => {
  const showPageUrl = showPoUrl && pageUrl;
  const poNumberNode = pdfUrl ? (
    <Tooltip title="Open latest PO PDF" placement="top" arrow>
      <Link
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        aria-label={`Open latest PDF for PO ${poNumber}`}
        sx={{
          display: "inline-flex",
          minWidth: "80px",
          fontSize: "1rem",
          fontWeight: 700,
          color: "inherit",
          cursor: "pointer",
          mb: showPageUrl ? 0.5 : 0,
        }}
      >
        {poNumber}
      </Link>
    </Tooltip>
  ) : (
    <Typography
      component="div"
      sx={{ fontWeight: 700, minWidth: "80px", mb: showPageUrl ? 0.5 : 0 }}
    >
      {poNumber}
    </Typography>
  );

  return (
    <Box>
      {poNumberNode}
      {showPageUrl ? (
        <Link
          href={pageUrl}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ fontSize: 13, fontWeight: 500 }}
        >
          URL
        </Link>
      ) : null}
    </Box>
  );
};

export default PurchaseOrderNumberCell;
